// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__ytq2a","upload":"Small_upload__3bbJ6","imageWrap":"Small_imageWrap__hRgrP","removeBtn":"Small_removeBtn__1k5K2"};